(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AttivitaDeleteController',AttivitaDeleteController);

    AttivitaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Attivita'];

    function AttivitaDeleteController($uibModalInstance, entity, Attivita) {
        var vm = this;

        vm.attivita = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Attivita.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
